const Current: {
  current: any
} = {
  current: null
}

export default Current
